import React from "react";
import PropTypes from "prop-types";
import { pure } from "recompose";
import styles from "./DateInfo.scss";
import { ThreeLevelInfo } from "~/components";
import { injectIntl, defineMessages, FormattedMessage, FormattedDate } from "react-intl";
import { dateDiffInDays } from "../../utils/date";
import classnames from "classnames";
import { NightIcon, Adults } from "../../theme/assets";

const msgs = defineMessages({
  arrival: {
    id: "date_info.arrival",
    description: "Arrival",
    defaultMessage: "Arrival",
  },
  departure: {
    id: "date_info.departure",
    description: "Departure",
    defaultMessage: "Departure",
  },
  nights: {
    id: "date_info.nights",
    description: "Night/s",
    defaultMessage: "Night/s",
  },
  stay: {
    id: "date_info.stay",
    description: "Stay",
    defaultMessage: "Stay",
  },
});

const monthAndDayToString = (date, formatDate) =>
  `${formatDate(date, { day: "2-digit" })} ${formatDate(date, { month: "short" }).substring(0, 3)}`;

const StayInfo = ({ startDate, endDate, numberOfGuests }) => {
  const stayDays = startDate && endDate && dateDiffInDays(startDate, endDate);
  const stayDaysString = stayDays || "-";
  if (numberOfGuests) {
    return (
      <div className={classnames(styles.stayInfoContainer)}>
        {stayDays && <div>{stayDaysString}</div>}
        {stayDays && (
          <div className={classnames(styles.nightIcon)}>
            <NightIcon />
          </div>
        )}
        {stayDays && <div className={styles.separator}>{" / "}</div>}
        <div>{numberOfGuests}</div>
        <div className={classnames(styles.guestIcon)}>
          <Adults />
        </div>
      </div>
    );
  }
  return <span>{stayDaysString}</span>;
};

function DateInfo({ startDate, endDate, numberOfGuests, className, intl: { formatDate } }) {
  const stayMessage = numberOfGuests ? msgs.stay : msgs.nights;
  return (
    <div className={classnames("wbkv9-DateInfo", styles.container, className)}>
      <ThreeLevelInfo
        firstLevel={<FormattedMessage {...msgs.arrival} />}
        secondLevel={(startDate && monthAndDayToString(startDate, formatDate)) || "-"}
        thirdLevel={
          startDate && (
            <span>
              <FormattedDate weekday="short" value={startDate} />
              {"  -  "}
              <FormattedDate year="numeric" value={startDate} />
            </span>
          )
        }
      />
      <ThreeLevelInfo
        firstLevel={<FormattedMessage {...msgs.departure} />}
        secondLevel={(endDate && monthAndDayToString(endDate, formatDate)) || "-"}
        thirdLevel={
          endDate && (
            <span>
              <FormattedDate weekday="short" value={endDate} />
              {"  -  "}
              <FormattedDate year="numeric" value={endDate} />
            </span>
          )
        }
      />
      <ThreeLevelInfo
        firstLevel={<FormattedMessage {...stayMessage} />}
        secondLevel={
          <StayInfo startDate={startDate} endDate={endDate} numberOfGuests={numberOfGuests} />
        }
      />
    </div>
  );
}

DateInfo.propTypes = {
  startDate: PropTypes.object,
  endDate: PropTypes.object,
};

export default injectIntl(pure(DateInfo));
